import React from 'react';
import { Image } from '@unpic/react';
import { buildImageUrl } from '@teetsh/app/src/utils/urls';

interface Props {
  s3Path: string;
  width: number;
  height: number;
  alt?: string;
  className?: string;
  options?: {
    focus?: 'face' | 'auto' | 'top' | 'top_left';
    zoom?: '0.5' | '0.7';
  };
}

export default function FixedImg(props: Props) {
  const { s3Path, alt, width, height, className, options } = props;
  const imageUrl = `${import.meta.env.VITE_IMAGEKIT_URL}/${s3Path}`;
  return (
    <Image
      src={buildImageUrl(imageUrl, 'imagekit', options || {})}
      cdn="imagekit" // force CDN because we use a custom domain
      alt={alt}
      layout="fixed"
      width={width}
      height={height}
      className={className}
    />
  );
}
